var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.025 41.0562C9.675 35.7762 0 22.979 0 15.7909C0 7.0697 7.16333 0 16 0C24.8333 0 32 7.0697 32 15.7909C32 22.979 22.25 35.7762 17.975 41.0562C16.95 42.3146 15.05 42.3146 14.025 41.0562ZM16 21.0545C18.9417 21.0545 21.3333 18.6941 21.3333 15.7909C21.3333 12.8876 18.9417 10.5272 16 10.5272C13.0583 10.5272 10.6667 12.8876 10.6667 15.7909C10.6667 18.6941 13.0583 21.0545 16 21.0545Z",
    fill: "#0066B3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default ForwardRef;